export const projectsData = [
  {
    title: "memeO",
    description: "iOS dating app based on memes",
    tags: ["React-Native", "Ruby on Rails", "PostgreSQL"],
    link: "https://github.com/tfrasc/memeO/",
    demo: null,
    icon: "/memeO_icon.png"
  },
  {
    title: "Cryptomon",
    description: "Web app for creating and battling NFT cards on the Ethereum blockchain",
    tags: ["Solidity", "React", "PostgreSQL"],
    link: "https://github.com/tfrasc/cryptomon/",
    demo: null
  },
  {
    title: "Taylor's Mugs",
    description: "Custom website for local artist who paints and sells coffee mugs",
    tags: ["Ruby on Rails", "Javascript", "PostgreSQL"],
    link: "https://github.com/tfrasc/taylorsmugs",
    demo: null
  },
  {
    title: "Radio Reddit",
    description: "Google Chrome Extension for Reddit to continuously play music from your favorite subreddits",
    tags: ["Javascript"],
    link: "https://github.com/tfrasc/Radio-Reddit-Chrome-Extension",
    demo: null,
    icon: "/radio-reddit.png"
  },
  {
    title: "Coinranking Plus",
    description: "Google Chrome Extension for Coinranking that adds favorites functionality",
    tags: ["Javascript"],
    link: "https://github.com/tfrasc/Coinranking-Plus",
    demo: null,
    icon: "/coinranking-plus.png"
  }
];

export const experienceData = [
  {
    title: "Senior Software Engineer",
    company: "Block / Square",
    period: "Nov 2021 – Feb 2026",
    featured: true,
    summary: "Primary engineer for Payment Links — owning reliability, international rollout, and cross-platform architecture. Drove the product to 99.99% SLO by resolving critical outages, mitigating DDoS SEVs, and leading a 23,000-merchant platform migration. Expanded global payment method support and designed a proxy service adopted across multiple teams.",
    metrics: [
      { value: "99.99%", label: "SLO Achieved" },
      { value: "66%", label: "Infra Load Reduced" },
      { value: "+24%", label: "User Signup Rate" },
    ],
    tagline: "Owned reliability, expansion, and platform architecture for Payment Links.",
    skills: ["Golang", "Laravel", "Kotlin", "React", "Ember", "Vue", "PostgreSQL", "MySQL"]
  },
  {
    title: "Software Engineer",
    company: "Block / Square",
    period: "May 2019 – Nov 2021",
    tagline: "Led Payment Links expansion across Japan, Canada, Australia, UK, and Ireland as sole engineer. Drove a multi-quarter onboarding initiative that increased seller verification completion by 23% and signup rate by 24%.",
    skills: ["Golang", "Laravel", "Ember", "Vue", "PostgreSQL", "MySQL"]
  },
  {
    title: "Software Engineering Intern",
    company: "Block / Square",
    period: "June 2018 – Aug 2018",
    tagline: "Contributed to Payment Links features and onboarding flows, laying the foundation for a full-time engineering role.",
    skills: ["Laravel", "Vue", "MySQL"]
  },
  {
    title: "Web Developer & Teaching Assistant",
    company: "Elevate Blue",
    period: "June 2016 – June 2018",
    tagline: "Shipped full-stack features across web and mobile at an early-stage startup — building RESTful APIs, third-party integrations, and React Native apps. Also served as a TA for an in-house coding bootcamp, mentoring students through a full-stack curriculum.",
    skills: ["Ruby on Rails", "Node.js", "React Native", "PostgreSQL", "MongoDB"]
  }
];

export const educationData = [
  {
    degree: "Bachelor of Science in Computer Science and Engineering",
    school: "University of Nevada, Reno",
    period: "2013 - 2018",
    description: "Comprehensive computer science education with focus on software engineering and algorithms. Minors in Cyber Security and Mathematics"
  }
];
